/**
 * File show-more-less.js.
 *
 * Handles showing more and less content on button click.
 */
import { $ } from './utils'

window.showMoreLess = (button) => {
  const wrapper = button.closest('.show-more-less-block')
  wrapper.classList.toggle('toggled')

  const toggled = wrapper.classList.contains('toggled')

  const less = $('div.less', wrapper)
  less.setAttribute('aria-hidden', toggled ? 'false' : 'true')

  button.setAttribute('aria-expanded', toggled ? 'true' : 'false')
}
